import { Api } from "./Api";
require('dotenv');
const axios = require('axios').default;

let AccountApi = {

    endpoint : "Accounts/",

    async add(item) {
        delete item.id;
        delete item.appStore;

        item.accountStatusChanges = []
        item.timesheetIds = []
        item.secondarySupervisors = []

        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint;
        const response = await axios.post(URL, item, { withCredentials: true });
        return response;
    },

    async update(item) {
        delete item.appStore;

        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint + item.id;

        const response = await axios.put(URL, item, { withCredentials: true });
        return response;
    },

    //Unique to the account, we need a way of adding status updates
    async addStatusUpdate(item) {
        const URL = process.env.REACT_APP_API_ENDPOINT + "AccountStatusChange/";

        const response = await axios.post(URL, item, { withCredentials: true });

        return response;
    }
}

//Add the Api Mixin
AccountApi = Object.assign({}, Api, AccountApi);

export { AccountApi };
